import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Users from './Users';
import SkillsBar from './components/SkillsBar';
import AddPosters from './components/AddPosters/AddPosters';
import Posters from './components/Posters/Posters';
import AdminSkillsBar from './components/AdminSkillsBar';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path='/' element={<App />} />
      <Route path='/users' element={<Users />} />
      <Route path='/skillsBar' element={<SkillsBar />} />
      <Route path='/Posters' element={<Posters />} />
      <Route path='/AddPosters' element={<AddPosters />} />
      <Route path='/AdminSkillsBar' element={<AdminSkillsBar />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
